// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '920763f0f3d91d84ec23ceacb93b4aa397f0517d';
export const BUILD_NUMBER = '222';
export const BUILD_TIMESTAMP = '2026-08-26T01:59:09.372Z';
